export function getView(value) {
  switch (value.event_type) {
    case 'appointment_bookings_state_update':
      return value.appointment_status && value.appointment_type_ids?.length

    case 'txs_status_update':
      return value.tx_status

    case 'custom_resource_insert':
      return value.custom_resource_type

    case 'patient_demographics_changed':
      return true

    case 'contract_signed':
      return true

    case 'order_status_changed':
      return true

    case 'document_signed':
      return true

    case 'medical_form_submitted':
      return true

    default:
      return false
  }
}
